import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack, HStack, Divider } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextHeadline } from '@cbhq/cds-web/typography';
import LanguageSelector from './LanguageSelector.js';
import messages from './messages.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function LanguageSelectorDrawer({
  closeSubmenu,
  userLocaleInfo,
  localeInformation
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/jsxs(VStack, {
    width: "100%",
    height: "100%",
    children: [/*#__PURE__*/jsx(HStack, {
      spacingHorizontal: 4,
      spacingVertical: 2,
      justifyContent: "space-between",
      alignItems: "center",
      children: /*#__PURE__*/jsxs(HStack, {
        children: [/*#__PURE__*/jsx(Pressable, {
          background: "transparent",
          accessibilityLabel: "back button",
          onPress: closeSubmenu,
          children: /*#__PURE__*/jsx(Icon, {
            size: "s",
            name: "caretLeft",
            spacingEnd: 3,
            color: "foreground"
          })
        }), /*#__PURE__*/jsx(TextHeadline, {
          as: "p",
          children: formatMessage(messages.title)
        })]
      })
    }), /*#__PURE__*/jsx(Divider, {
      spacingTop: 1
    }), /*#__PURE__*/jsx(LanguageSelector, {
      userLocaleInfo: userLocaleInfo,
      localeInformation: localeInformation
    })]
  });
}
const LanguageSelectorDrawer$1 = /*#__PURE__*/memo(LanguageSelectorDrawer);
export { LanguageSelectorDrawer$1 as default };
//# sourceMappingURL=LanguageSelectorDrawer.js.map
